// Piezas propias del panel de detalle de una promo; las comunes de formulario salen de `EditorForm`.
export {
    FIELD_INPUT,
    FIELD_LABEL,
    FieldMessage,
    LiveInline,
    SECTION,
    SectionTitle,
    Unit,
} from '@/shared/patterns/EditorForm';

/** Los campos en línea de una palanca (`.pal-inputs input`). */
export const INLINE_INPUT =
    'w-[60px] rounded border border-border bg-background px-[7px] py-1 text-[11px] text-foreground outline-none focus:border-ring focus:ring-2 focus:ring-ring/15 aria-[invalid=true]:border-destructive';

/** El campo de la franja de presupuesto (`.budget-strip input`); lo reusan los usos del código. */
export const STRIP_INPUT =
    'w-[130px] flex-none rounded border border-border bg-background px-2 py-[5px] text-xs text-foreground outline-none focus:border-ring focus:ring-2 focus:ring-ring/15 aria-[invalid=true]:border-destructive';

/** La franja con borde de color del mock (`.budget-strip`). */
export const STRIP =
    'flex items-center gap-2 rounded-md border-l-[3px] border-l-primary bg-muted/30 px-3 py-2';

/** La etiqueta en mayúsculas de la franja. */
export const STRIP_LABEL =
    'text-[10px] font-bold uppercase tracking-[0.04em] text-muted-foreground';

export const INLINE_SELECT =
    'rounded border border-border bg-background px-1 py-1 text-[11px] text-foreground outline-none focus:border-ring';
